import { CSSProperties } from "react";
import { ITheme } from "../../utils/theme";

export const fieldLabelStyle = {
  fontFamily: 'Verdana, Arial, Helvetica, sans-serif',
  fontSize: '11px',
  color: 'grey.900',
  display: 'inline',
  fontWeight: 'bold',
  marginRight: 1,
}

export const slipLocationStyle = {
  color: (theme: ITheme) => theme.palette.red[300],
  fontWeight: 'bold'
}

export const tableCellStyle = (theme: ITheme, backgroundColor: string, width = "auto") => ({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'grey.A400',
  borderTop: 'none',
  backgroundColor: backgroundColor ?? theme.palette.red[400],
  padding: '3px',
  fontWeight: 'bold',
  fontSize: '11px',
  color: 'black',
  width,
});

export const tableStyle = {
  backgroundColor: 'grey.A700',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'grey.A400',
}

export const uppercaseMainText = {
  fontWeight: '700',
  fontSize: '11px',
  color: 'black',
  fontFamily: 'Verdana, Arial, Helvetica, sans-serif',
}

export const paginationStyles = {
  background: 'white',
  padding: 0,
  paddingTop: 1,
  paddingBottom: 1,
}

export const iconStyle: CSSProperties = {
  display: 'inline-block',
  textAlign: 'right',
  paddingLeft: '8px',
  position: 'relative',
  top: '5px'
}